export default __webpack_public_path__ + "static/media/home_white_icon.da57856c.svg";